import React, { FC } from 'react';
import MuiTab, { TabProps as MuiTabProps } from '@mui/material/Tab';
import { styled } from '../../styles';
import { BpDesignSystem } from '../../types';
import { mergeClassNames } from '../../utils/cssClassNameHelper';

export interface TabProps extends BpDesignSystem.Props<MuiTabProps> {
  selected?: boolean;
}

export const Tab: FC<TabProps> = ({ dataTest, icon, label, selected, className, ...props }) => {
  return (
    <MuiTab
      {...props}
      className={mergeClassNames(className, {
        'Mui-selected': selected
      })}
      aria-selected={selected}
      label={
        <StyledTabLabel>
          {icon}
          <span>{label}</span>
        </StyledTabLabel>
      }
      data-test={dataTest}
    />
  );
};

export const StyledTabLabel = styled('span')`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ theme }) => theme.spacingSize.s};
`;
